import React, { useState } from "react";
import classnames from "classnames";

import { GOODSSORT } from "../../constant";

import styles from "./GoodsSort.module.css";

interface Props {
  active: string;
  handler: (active: string) => void;
  reset: () => void;
  search: (keyword: string) => void;
}

const {
  enableProductsKeywordSearch
} = window.pageConfig;

function GoodsSort(props: Props) {
  const { active, handler, reset, search } = props;
  const [keywords, setKeywords] = useState("");
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <dl className={styles.sort}>
          <dt className={styles.label}>排序</dt>
          <dd className={styles.value}>
            {GOODSSORT.map((item, index) => {
              const { down, name, up } = item;
              return (
                <button
                  key={index}
                  className={classnames(styles.handler, {
                    [styles.active]: active === down || active === up,
                    [styles.down]: active === down,
                    [styles.isDefault]: down === "8" || up === "8",
                    [styles.up]: active === up,
                  })}
                  onClick={() => handler(active === up ? down : up)}
                >
                  {name}
                </button>
              );
            })}
          </dd>
        </dl>
        <button className={styles.reset} onClick={reset}>
          重置
        </button>
        {enableProductsKeywordSearch && <div className={styles.keywords}>
          <input
            className={styles.input}
            onChange={(event) => {
              const { target } = event;
              const { value } = target;
              setKeywords(
                value.replace(/[`~!@#$%^&*()_+<>?:"{},./;'[\]]/g, "")
              );
            }}
            placeholder="标的物名称"
            type="text"
            value={keywords}
          />
          <button
            className={styles.submit}
            onClick={() => search(keywords)}
          ></button>
        </div>}
      </div>
    </div>
  );
}

export default GoodsSort;
